<template>
    <dialog-fullscreen :visibility.sync='visibility' :indicator='indicator'>
        <template v-slot:title>Обновление источника данных</template>
        <template v-slot:action>
            <v-btn
                    text
                    :disabled='!validStatplace'
                    :loading='indicator'
                    color='green darken-2'
                    @click='updateStatplace'
            >
                Обновить
            </v-btn>
        </template>
        <template v-slot:content>
            <v-form v-model='validStatplace' style='min-width: 320px; max-width: 420px;'>
                <v-text-field v-model="provider.source_type_provider" disabled label='Провайдер'></v-text-field>
                <v-text-field v-model="source.source_type_name" disabled label='Источник'></v-text-field>
                <v-text-field v-model="statplace.source_name" :rules="[rules.required]"
                              label='Отображаемое название'></v-text-field>
                <!-- FUNNEL -->
                <template v-if='source.source_type_provider == "Funnel"'>
                    <v-text-field :rules="[rules.required]" v-model="statplace.source_ext.account_id"
                                  label='Идентификатор кабинета в источнике'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model="statplace.source_int.account_id"
                                  label='Идентификатор проекта Funnel'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model="statplace.source_int.source_id"
                                  label='Идентификатор кабинета в экспорте'></v-text-field>
                </template>
                <!-- JETSTAT -->
                <template v-if='source.source_type_provider == "JetStat"'>
                    <v-text-field v-model="statplace.source_ext.account_id"
                                  label='Идентификатор кабинета в источнике'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model="statplace.source_int.account_id"
                                  label='Идентификатор отчета в JetStat'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model="statplace.source_int.source_id"
                                  label='Идентификатор кабинета в экспорте'></v-text-field>
                </template>
                <!-- myTarget -->
                <template v-if='statplace.source_type_id == "mytarget"'>
                    <v-autocomplete
                            :loading='mt.list' :items='mt.resources' label='Логин myTarget'
                            v-model="statplace.source_ext.parent" single-line
                            :disabled='mt.add'
                            @change='getMTResources'
                    >
                        <template slot='append-outer'>
                            <v-btn icon small @click='mt.add = true'>
                                <v-icon>add</v-icon>
                            </v-btn>
                        </template>
                    </v-autocomplete>
                    <v-text-field v-if='mt.add' v-model="statplace.source_ext.parent" label='Логин myTarget'>
                        <template slot='append-outer'>
                            <v-btn text small @click='openMTWindow'>Подключить</v-btn>
                        </template>
                    </v-text-field>
                    <v-text-field v-model="mtAccountInfo.type" label='Тип пользователя' disabled
                                  :loading='mt.get'></v-text-field>
                    <v-text-field v-model="mtAccountInfo.currency" label='Валюта' disabled
                                  :loading='mt.get'></v-text-field>
                    <v-text-field v-model="mtAccountInfo.id" label='Идентификатор аккаунта' disabled
                                  :loading='mt.get'></v-text-field>
                </template>
                <!-- AppsFlyer / Adjust-->
                <template v-if='["appsflyer", "adjust"].includes(statplace.source_type_id)'>
                    <v-select
                            :items='[{"text": "iOS", "value": "iOS"}, {"text": "Android", "value": "Android"}]'
                            label='Платформа' v-model="statplace.source_ext.platform"
                            :rules="[rules.required]" single-line
                    ></v-select>
                </template>
                <!-- AppsFlyer Internal-->
                <template v-if='["appsflyer_internal"].includes(statplace.source_type_id)'>
                    <v-text-field v-model = "statplace.source_int.app_id" label='ID приложения'></v-text-field>
                    <v-text-field v-model = "statplace.source_int.token" label='Токен доступа'></v-text-field>
                    <v-select
                            :items='[{"text": "iOS", "value": "ios"}, {"text": "Android", "value": "android"}]'
                            label='Платформа' v-model="statplace.source_int.app_platform"
                            :rules="[rules.required]" single-line
                    ></v-select>
                    <v-select
                            :items='[{"text": "Partners Daily", "value": "partners_by_date"}, {"text": "Geo Daily", "value": "geo_by_date"}]'
                            label='Тип отчета' v-model="statplace.source_int.report_type"
                            :rules="[rules.required]" single-line
                    ></v-select>
                    <v-select :items='[{"text": "Europe / Moscow", "value": "Europe%2fMoscow"}, {"text": "America / Mexico City", "value": "America%2fMexico_City"}, {"text": "UTC", "value": "UTC"}]' label='Часовой пояс' v-model = "statplace.source_int.timezone" :rules = "[rules.required]" single-line></v-select>
                </template>
                <!-- Callkeeper -->
                <template v-if='statplace.source_type_id == "callkeeper"'>
                    <v-text-field :rules="[rules.required]" v-model="statplace.source_ext.account_id"
                                  label='Логин кабинета'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model='statplace.source_int.token'
                                  label='API-ключ из ЛК'></v-text-field>
                </template>
                <!-- Calltouch -->
                <template v-if='statplace.source_type_id == "calltouch"'>
                    <v-text-field
                            :disabled='touch.success' :success='touch.success'
                            :rules="[rules.required]" v-model='statplace.source_int.token' label='API-ключ из ЛК'
                    ></v-text-field>
                    <v-text-field
                            :disabled='touch.success' :success='touch.success'
                            :rules="[rules.required]"
                            v-model='statplace.source_ext.site_id' label='Идентификатор сайта'
                    ></v-text-field>
                    <v-btn :disabled='touch.success' depressed small block @click='touchGrants'
                           :loading='touch.progress'>
                        <v-icon left>offline_bolt</v-icon>
                        <span>Проверить доступ</span>
                    </v-btn>
                </template>
                <!-- Comagic -->
                <template v-if='statplace.source_type_id == "comagic"'>
                    <v-select
                            :disabled='touch.success'
                            :items="[{'text': 'Ключ доступа', 'value': 'token'}, {'text': 'Логин/Пароль', 'value': 'password'}]"
                            label='Вариант доступа' item-text='text' item-value='value'
                            v-model="statplace.source_int.auth_flow"
                            :rules="[rules.required]" single-line
                    ></v-select>
                    <v-text-field
                            :disabled='touch.success'
                            :success='touch.success'
                            :rules="[rules.required]"
                            v-model='statplace.source_int.login'
                            :label='statplace.source_int.auth_flow == "password"?"Логин в системе":"Название ключа"'
                            :error='touch.error.status'
                    ></v-text-field>
                    <v-text-field
                            :disabled='touch.success'
                            :success='touch.success'
                            :rules="[rules.required]"
                            v-model='statplace.source_int.token'
                            :error='touch.error.status'
                            :error-messages='touch.error.messages'
                            @keyup='touch.error.status=false;touch.error.messages=[];'
                            :label='statplace.source_int.auth_flow == "password"? "Пароль в системе":"API-ключ"'
                    ></v-text-field>
                    <v-btn :disabled='touch.success' depressed small block @click='touchGrants'
                           :loading='touch.progress'>
                        <v-icon left>offline_bolt</v-icon>
                        <span>Проверить доступ</span>
                    </v-btn>
                    <v-text-field disabled label='Идентификатор сайта'
                                  v-model='statplace.source_ext.site_id'></v-text-field>
                </template>
                <!-- DBM -->
                <template v-if='statplace.source_type_id == "doubleclick_bidmanager_api"'>
                    <v-text-field :rules="[rules.required]" v-model='statplace.source_ext.publisher_id'
                                  label='Publisher ID'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model='statplace.source_ext.advertiser_id'
                                  label='Advertiser ID'></v-text-field>
                </template>
                <!-- Google Analytics -->
                <template v-if='statplace.source_type_id == "ga"'>
                    <v-text-field disabled label='Аккаунт GA' v-model="statplace.source_ext.parent"></v-text-field>
                    <v-text-field disabled label='Ресурс' v-model="statplace.source_ext.property_id"></v-text-field>
                    <v-text-field disabled label='Представление'
                                  v-model="statplace.source_ext.profile_id"></v-text-field>
                    <v-text-field label='Фильтрация данных' v-model="statplace.source_int.filter"></v-text-field>
                    <v-textarea
                            label="Показатели"
                            v-model="statplace.meta.route_metrics"
                            disabled="disabled"
                    ></v-textarea>

                    <v-textarea
                            label="Параметры"
                            v-model="statplace.meta.route_dimensions"
                            disabled="disabled"
                    ></v-textarea>
                </template>
                <!-- Google Sheets -->
                <template v-if='statplace.source_type_id == "gsheets"'>
                    <v-text-field :rules="[rules.required]" v-model='statplace.source_ext.document_id'
                                  label='ID файла (из ссылки)'></v-text-field>
                    <v-text-field :rules="[rules.required, rules.url]" v-model='statplace.source_ext.document_url'
                                  label='Ссылка на файл'></v-text-field>
                </template>
                <!-- Maxposter -->
                <template v-if='statplace.source_type_id == "maxposter"'>
                    <v-text-field v-model="statplace.source_int.login" label='Логин кабинета'></v-text-field>
                    <v-text-field :rules="[rules.required]" v-model='statplace.source_int.token'
                                  label='API-ключ из ЛК'></v-text-field>
                </template>
                <!-- Smartcallback -->
                <template v-if='statplace.source_type_id == "smartcallback"'>
                    <v-text-field :disabled='touch.success' :success='touch.success' :rules="[rules.required]"
                                  v-model='statplace.source_int.token' label='Токен доступа'></v-text-field>
                    <v-text-field :disabled='touch.success' :success='touch.success' :rules="[rules.required]"
                                  v-model='statplace.source_int.client_id' label='Идентификатор клиента'></v-text-field>
                    <v-text-field :disabled='touch.success' :success='touch.success' :rules="[rules.required]"
                                  v-model='statplace.source_int.client_token' label='Токен клиента'></v-text-field>
                    <v-text-field :disabled='touch.success' :success='touch.success' :rules="[rules.required]"
                                  v-model='statplace.source_int.signature'
                                  label='Подпись для запросов (Signature)'></v-text-field>
                    <v-btn :disabled='touch.success' depressed small block @click='touchGrants'
                           :loading='touch.progress'>
                        <v-icon left>offline_bolt</v-icon>
                        <span>Проверить доступ</span>
                    </v-btn>
                    <v-text-field disabled label='Идентификатор сайта'
                                  v-model='statplace.source_ext.site_id'></v-text-field>
                </template>
                <!-- Yandex Metrika -->
                <template v-if='["yametrika", "appmetriсa"].includes(statplace.source_type_id)'>
                    <v-text-field disabled label='Аккаунт Яндекса' v-model="statplace.source_ext.parent"></v-text-field>
                    <v-text-field disabled label='Счетчик' v-model="statplace.source_int.source_id"></v-text-field>
                </template>
                <v-menu ref="selectedDate" :close-on-content-click="false"
                        :return-value.sync="statplace.meta.date_start" offset-y v-model='selectedDate'>
                    <template v-slot:activator='{ on }'>
                        <v-text-field v-on='on' v-model='statplace.meta.date_start' readonly
                                      label='Дата начала статистики' :rules="[rules.required]"></v-text-field>
                    </template>
                    <v-date-picker :rules="[rules.required]" style='width: 100%;'
                                   :header-color='$store.getters.uiAccent' v-model='statplace.meta.date_start'
                                   @input="$refs.selectedDate.save(statplace.meta.date_start)" locale='ru-ru'
                                   min='2018-01-01' first-day-of-week='1'></v-date-picker>
                </v-menu>
            </v-form>
        </template>
    </dialog-fullscreen>
</template>
<script>
    import DialogFullscreen from '@/components/elements/dialogs/Fullscreen.vue'
    import dayjs from 'dayjs'
    import uuid4 from 'uuid4'
    import 'dayjs/locale/ru'
    import {orderBy} from 'lodash-es'

    export default {
        name: 'UserStatplaceUpdateMenu',
        props: ['postAction', 'statplace', 'initialState'],
        components: {'dialog-fullscreen': DialogFullscreen},
        data() {
            return {
                validStatplace: false,
                statplaces: [],
                visibility: false,
                visibilitySecondary: this.initialState,
                indicator: false,
                indicatorSecondary: false,
                defaultStatsDate: dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
                selectedDate: false,
                touch: {
                    error: {
                        status: false,
                        messages: []
                    },
                    success: false,
                    results: {},
                    progress: false
                },
                ga: {
                    list: false,
                    get: false,
                    accounts: [],
                    resources: [],
                    credentials: {},
                    selection: {}
                },
                ya: {
                    list: false,
                    get: false,
                    credentials: {},
                    accounts: [],
                    counters: [],
                    selection: {}
                },
                mt: {
                    add: false,
                    get: false,
                    list: false,
                    credentials: {},
                    resources: []
                },
                rules: {
                    required: value => !!value || 'Обязательное поле.',
                    url: value => {
                        const pattern = /(https?:\/\/[^\s]+)/g
                        return pattern.test(value) || 'Нераспознанный формат ссылки'
                    }
                }
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
            }
        },
        computed: {
            source() {
                const source = this.$store.state.sourceTypes.filter(s => s.source_type_id == this.statplace.source_type_id)
                return source[0] || {source_type_name: '_blank'}
            },
            provider() {
                const provider = this.$store.state.sourceTypes.filter(s => s.source_type_id == this.statplace.source_type_id)
                return provider[0]  || {source_type_name: '_blank'}
            }
        },
        methods: {
            updateStatplace() {
                this.indicator = true
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    login: this.$store.getters.userLogin
                }
                this.$http.put(this.$store.getters.endpoint + '/db/project/' + this.statplace.project_id + '/statplaces', {
                    ...requestData,
                    ...{'statplace': this.statplace}
                }, {
                    headers: {
                        ...this.$store.state.restrictedHeaders,
                        ...requestHeaders
                    }
                }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.indicator = false;
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'update',
                                target: 'project_source'
                            },
                            once: false
                        })
                        this.visibility = false;
                        this.postAction('statplaces');
                    } else {
                        this.errorCreate = true;
                        this.errorCreateMessage = ['Идентификатор уже используется в другом объекте']
                        console.log(response)
                    }
                }, (r) => {
                    this.indicator = false;
                    let error = r.body;
                    console.log(error)
                });

            },
            touchGrants() {
                this.touch.progress = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                };
                if (this.statplace.source_type_id == 'comagic') {
                    this.statplace.source_int.api_version = 2;
                }
                let requestData = {
                    'login': this.$store.getters.userLogin,
                    'statplace': this.statplace
                };
                this.$http.post(this.$store.getters.endpoint + '/db/touch_access',
                    requestData, {
                        headers: {...this.$store.state.restrictedHeaders, ...requestHeaders}
                    }).then((r) => {
                    let response = r.body;
                    this.touch.progress = false;
                    if (response.result) {
                        this.touch.results = response;
                        this.touch.success = true;
                    } else {
                        this.touch.error.status = true;
                        if (response.step == 'Auth') {
                            this.touch.error.messages.push('Авторизационные данные неверны или доступ к API не открыт для всех IP-адресов')
                            setTimeout(function () {
                                this.touch.error.status = false;
                                thos.touch.error.messages = []
                            }, 1500);
                        }
                        console.log(response)
                    }
                })
            }
        }
    }
</script>
